import { service } from '../../../helpers/http'

export const ActionFindStates = ({ dispatch }, payload) => {

    return service({
        module: 'state',
        action: 'find',
        payload: payload
    })
    
}

export const ActionCreateState = ({ dispatch }, payload) => {
    
    return service({
        module: 'state',
        action: 'create',
        payload: payload
    })
    
}

export const ActionUpdateState = ({ dispatch }, payload) => {
    
    return service({
        module: 'state',
        action: 'update',
        payload: payload
    })
}

export const ActionDeleteState = ({ dispatch }, payload) => {
    
    return service({
        module: 'state',
        action: 'delete',
        payload: payload
    })
    
}

